import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ProductCondition } from '@product/const';
import { Observable } from 'rxjs';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct } from '../store/product-state';
import { ProductSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductConditionsService {
  constructor(private store: Store<StateWithProduct>) {}

  loadProductConditions(productCode: string): void {
    this.store.dispatch(new CustomProductActions.LoadProductConditions(productCode));
  }

  getProductConditions(productCode: string): Observable<ProductCondition[]> {
    return this.store.pipe(select(ProductSelectors.getProductConditionsValue(productCode)));
  }

  getProductConditionsLoading(productCode: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getProductConditionsLoading(productCode)));
  }

  getProductConditionsSuccess(productCode: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getProductConditionsSuccess(productCode)));
  }

  getProductConditionsError(productCode: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getProductConditionsError(productCode)));
  }
}
